export const welcome = {
    template: `
    <div class="md-padding">
    
    <h3>Welcome</h3>
    
    </div>`
};